import * as React from 'react';
import clsx from 'clsx';
import { NoSymbolIcon } from '@heroicons/react/24/outline';
import bannedIcon from '@/assets/images/svg/banned_icon.svg';
import { ConsentCheckbox } from '../ConsentCheckbox';

const BANNED_TOPICS = ['Hate speech', 'Illegal activities', 'Sexual content', 'Self Harm talk'];

interface BannedContentNoticeProps {
  acknowledged: boolean;
  onToggle: (checked: boolean) => void;
}

export const BannedContentNotice: React.FC<BannedContentNoticeProps> = ({
  acknowledged,
  onToggle,
}) => (
  <div className={clsx('flex w-full flex-col gap-6', 'p-0')}>
    {/* Header */}
    <div className='flex items-start gap-4'>
      {/* Icon Container: Matches other sections (40x40, Radius 13px, Purple BG) */}
      <div className='flex size-[40px] shrink-0 items-center justify-center rounded-[13px] bg-brand-750'>
        <img src={bannedIcon} alt='Banned Content' className='size-6 object-contain' />
      </div>
      <div className='flex flex-col gap-1'>
        <h4 className='font-sans text-20 font-medium leading-27 text-dark-100'>
          BANNED CONTENT (Always Prohibited)
        </h4>
        <p className='font-sans text-13 font-normal leading-[18px] text-gray-600'>
          The following topics are PERMANENTLY BANNED and cannot be discussed:
        </p>
      </div>
    </div>

    {/* Topics Grid */}
    <div className='grid grid-cols-1 gap-3 sm:grid-cols-2 md:pl-[64px]'>
      {BANNED_TOPICS.map((topic) => (
        <div
          key={topic}
          className={clsx(
            'flex items-center justify-between px-4 py-3',
            'rounded-10',
            'bg-red-250', // #FD8D8D
            'border border-gray-750' // #3C3C3C
          )}
        >
          <span className='font-sans text-16 font-normal text-brand-800'>{topic}</span>
          <NoSymbolIcon className='size-6 text-gray-750' strokeWidth={1.5} />
        </div>
      ))}
    </div>

    {/* Warning Text */}
    <p className='font-sans text-14 font-normal leading-21 tracking-normal text-gray-600 md:pl-[64px]'>
      *You must acknowledge this policy before saving your Echo personality
    </p>

    <div className='md:pl-[64px]'>
      <ConsentCheckbox
        checked={acknowledged}
        onChange={onToggle}
        label='I acknowledge the banned content policy'
      />
    </div>
  </div>
);

export default BannedContentNotice;
